import React, { ReactNode } from 'react';

import maintenanceFormSchema, { MaintenanceFormSchema } from 'core/schemas/maintenanceForm';
import { Form, FormSubmitHandler } from 'Elements/Form';

type Props = {
  onSubmit: FormSubmitHandler<MaintenanceFormSchema>;
  maintenance?: MaintenanceFormSchema['maintenance'];
  children: ReactNode;
  id?: number;
};

export default function MaintenanceForm({
  onSubmit,
  maintenance,
  children,
  id
}: Props) {
  return (
    <Form
      validationSchema={maintenanceFormSchema.meta({ maintenanceId: id })}
      onSubmit={onSubmit}
      initialValues={{ maintenance }}
    >
      {children}
    </Form>
  );
}
